export default __webpack_public_path__ + "static/media/shin-eye.fd11c904.png";